import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import './styles.pcss';

const propTypes = {
  centered: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  size: PropTypes.oneOf([
    'xsmall',
    'small',
    'medium',
    'large',
    'xlarge',
  ]),
};
const defaultProps = {
  centered: false,
  className: undefined,
  children: null,
  size: undefined,
};

export default function LayoutContainer({
  centered,
  className,
  children,
  size,
}) {
  return (
    <div
      className={cn(
        className,
        'layout-container',
        centered && 'layout-container_centered',
        size && `layout-container_size_${size}`
      )}
    >
      {children}
    </div>
  );
}

LayoutContainer.propTypes = propTypes;
LayoutContainer.defaultProps = defaultProps;
